import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Dashboard from "./Dashboard";
import DashboardPsychiatrist from "./DashboardPsychiatrist";
import { useSelector } from "react-redux";

// Not sure about these two
// import Basic from "./Basic";
import { LayoutSplashScreen } from "../../../_metronic";

// Admin Pages
import InterestedPsychologists from "./admin/InterestedPsychologists";
import RegisteredPsychologists from "./admin/RegisteredPsychologists";
import Referrers from "./admin/Referrers";
import Clients from "./admin/Clients";
import { ClientInvitesAdmin } from "./admin/ClientInvites";
import MedicalPractitioners from "./admin/MedicalPractitioners";
import MedicalPractices from "./admin/MedicalPractices";
import SearchClientData from "./admin/SearchClientData";
import SearchBookingData from "./admin/SearchBookingData";
import Notifications from "./admin/Notifications";
// import Referrals from "./admin/Referrals";
import Faxes from "./admin/Faxes";
import VerifyXero from "./admin/VerifyXero";
import VerifyNDISXero from "./admin/VerifyNDISXero";
import Invoices from "./admin/Invoices";
import InvoiceContracts from "./admin/InvoiceContracts";
import InvoiceNthQLDPHN from "./admin/InvoiceNthQLDPHN";
import InvoiceNDIS from "./admin/InvoiceNDIS";
import InvoiceLog from "./admin/InvoiceLog";
import GatherBillable from "./admin/GatherBillable";
import GatherBillableAll from "./admin/GatherBillableAll";
import GatherBillableContracts from "./admin/GatherBillableContracts";
import GatherBillableNthQLDPHN from "./admin/GatherBillableNthQLDPHN";
import GatherBillableNDIS from "./admin/GatherBillableNDIS";
import GatherBillableContractsProvider from "./admin/GatherBillableContractsProvider";
import GatherBillableNDISProvider from "./admin/GatherBillableNDISProvider";
import ProfileAdmin from "./admin/ProfileAdmin";
import PaymentNDIS from "./admin/PaymentNDIS";
import PaymentContracts from "./admin/PaymentContracts";
// import Cancellations from "./admin/Cancellations";
import CsCentres from "./CentralisedService/CsCentres";
import CsCentresAdmin from "./CentralisedService/CsCentresAdmin";
import CsClosuresAdmin from "./CentralisedService/CsClosuresAdmin";
import CsAgents from "./CentralisedService/CsAgents";
import CsClients from "./CentralisedService/CSClients";
import CsProviderList from "./CentralisedService/CSProviderList";
import CsClientRegistration from "./CentralisedService/CSClientRegistration";
import CSClientClose from "./CentralisedService/CSClientClose";
import AdminReporting from "./configuration/AdminReporting";
import AdminUsers from "./configuration/AdminUsers";
import MetaDataConfig from "./configuration/MetaDataConfig";
import FormConfig from "./admin/FormConfigAdmin";
import Contracts from "./admin/Contracts";
import Programs from "./configuration/Programs";
import Surveys from "./configuration/Surveys";
import SurveyResults from "./configuration/SurveyResults";
import RecentArchived from "./configuration/RecentArchived";
import NthQLDPHNStatistics from "./configuration/NthQLDPHNStatistics";
import ProviderStatistics from "./configuration/ProviderStatistics";
import Opportunity from "./configuration/Opportunity";
import MedipassCodes from "./admin/MedipassCodes";
import BillingServices from "./configuration/BillingServices";
import HowToArticles from "./KnowledgeBase/HowToArticles";
import Resources from "./KnowledgeBase/Resources";
import Policies from "./KnowledgeBase/Policies";

// Reference Pages
// import UserRoles from "./reference/UserRoles";

export default function HomePageAdmin() {
  const roleScope = useSelector((state) => state.auth.roleScope);
  if (roleScope === "Provisional") {
    return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to="/dashboard" />
          }
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/interestedpsychologists" component={InterestedPsychologists} />
          <Route path="/registeredpsychologists" component={RegisteredPsychologists} />
          <Route path="/provisionalclients" render={(props) => <Clients {...props} clienttype={`Provisional`} />} />
          <Route path="/gpclients" render={(props) => <Clients {...props} clienttype={`GP`} />} />
          <Route path="/clientinvites" component={ClientInvitesAdmin} />
          <Redirect to="/error/error-v1" />
        </Switch>
      </Suspense>
    );
  } else if (roleScope === "Psychiatrist") {
    return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to="/dashboardPsychiatrist" />
          }
          <Route path="/dashboard" component={DashboardPsychiatrist} />
          <Route path="/registeredProviders" component={RegisteredPsychologists} />
          <Route path="/csclients" component={CsClients} />
          <Route path="/adminprofile" component={ProfileAdmin} />
          <Redirect to="/error/error-v1" />
        </Switch>
      </Suspense>
    );
  } else {
    return (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to="/dashboard" />
          }
          <Route path="/dashboard" component={Dashboard} />

          {/* Admin Pages */}
          <Route path="/interestedpsychologists" component={InterestedPsychologists} />
          <Route path="/registeredpsychologists" component={RegisteredPsychologists} />

          <Route path="/referrers" component={Referrers} />

          <Route path="/psychologyclients" render={(props) => <Clients {...props} clienttype={`Psychologist`} />} />
          <Route path="/financialclients" render={(props) => <Clients {...props} clienttype={`Financial`} />} />
          <Route path="/gpclients" render={(props) => <Clients {...props} clienttype={`GP`} />} />
          <Route path="/provisionalclients" render={(props) => <Clients {...props} clienttype={`Provisional`} />} />
          <Route path="/socialclients" render={(props) => <Clients {...props} clienttype={`Social`} />} />
          <Route path="/nurseclients" render={(props) => <Clients {...props} clienttype={`Nurse`} />} />
          <Route path="/occupationalclients" render={(props) => <Clients {...props} clienttype={`Occupational`} />} />
          <Route path="/supervisionclients" render={(props) => <Clients {...props} clienttype={`Supervision`} />} />
          <Route path="/ndisclients" render={(props) => <Clients {...props} clienttype={`NDIS`} />} />
          <Route path="/unassociated" render={(props) => <Clients {...props} clienttype={`Unassociated`} />} />
          <Route path="/nthqldphnclients" render={(props) => <Clients {...props} clienttype={`NthQLDPHN`} />} />
          <Route path="/eapcontractclients" render={(props) => <Clients {...props} clienttype={`EAPContract`} />} />
          <Route path="/privateclients" render={(props) => <Clients {...props} clienttype={`Private`} />} />
          <Route path="/codes" component={MedipassCodes} />
          <Route path="/billingservices" component={BillingServices} />
          {/* Knowledge Base Pages */}
          <Route path="/howtoarticles" component={HowToArticles} />
          <Route path="/resources" component={Resources} />
          <Route path="/policies" component={Policies} />

          <Route path="/searchclientdata" component={SearchClientData} />
          <Route path="/searchbookingdata" component={SearchBookingData} />
          <Route path="/clientinvites" component={ClientInvitesAdmin} />
          <Route path="/medicalpractitioners" component={MedicalPractitioners} />
          <Route path="/medicalpractices" component={MedicalPractices} />
          <Route path="/faxes" component={Faxes} />
          <Route path="/notifications" component={Notifications} />
          {/* <Route path="/referrals" component={Referrals} /> */}
          <Route path="/xeroverify" component={VerifyXero} />
          <Route path="/xerondisverify" component={VerifyNDISXero} />
          <Route path="/gatherbillableall" component={GatherBillableAll} />
          <Route path="/gatherbillable" component={GatherBillable} />
          <Route path="/gathercontracts" component={GatherBillableContracts} />
          <Route path="/gatherndis" component={GatherBillableNDIS} />
          <Route path="/gathercontractsprovider" component={GatherBillableContractsProvider} />
          <Route path="/gatherndisprovider" component={GatherBillableNDISProvider} />

          <Route path="/gathernthqldphn" component={GatherBillableNthQLDPHN} />
          <Route path="/nthqldphninv" component={InvoiceNthQLDPHN} />
          <Route path="/invoices" component={Invoices} />
          <Route path="/contractinv" component={InvoiceContracts} />
          <Route path="/contractpay" component={PaymentContracts} />
          <Route path="/ndisinv" component={InvoiceNDIS} />
          <Route path="/ndispay" component={PaymentNDIS} />
          <Route path="/invoicelog" component={InvoiceLog} />
          <Route path="/adminprofile" component={ProfileAdmin} />

          {/* Centralised Service */}
          <Route path="/cscentres" component={CsCentres} />
          <Route path="/cscentresadmin" component={CsCentresAdmin} />
          <Route path="/csclosuresadmin" component={CsClosuresAdmin} />
          <Route path="/csagents" component={CsAgents} />
          <Route path="/csclients" component={CsClients} />
          <Route path="/csproviderlist" component={CsProviderList} />
          <Route path="/csclientregistration" component={CsClientRegistration} />
          <Route path="/csclientclose" component={CSClientClose} />

          {/* Reference Pages */}
          <Route path="/adminreporting" component={AdminReporting} />
          <Route path="/adminusers" component={AdminUsers} />
          <Route path="/metadataconfig" component={MetaDataConfig} />
          <Route path="/forms" component={FormConfig} />
          <Route path="/contracts" component={Contracts} />
          <Route path="/programs" component={Programs} />
          <Route path="/surveys" component={Surveys} />
          <Route path="/surveyresults" component={SurveyResults} />
          <Route path="/recentarchived" component={RecentArchived} />
          <Route path="/providerstatistics" component={ProviderStatistics} />
          <Route path="/nthqldphnstatistics" component={NthQLDPHNStatistics} />
          <Route path="/opportunity" component={Opportunity} />

          <Redirect to="/error/error-v1" />
        </Switch>
      </Suspense>
    );
  }
}
